import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export function setupFinanceiro(): void {
  const modules = [
    {
      entry: 'receber-boletos-email',
      id: 'receber-boletos-email',
      name: 'beneficiary.receber-boletos-email',
      route: Routes.RECEBER_BOLETOS_EMAIL,
      order: 1,
      closeable: true,
    },
    {
      entry: 'mensalidades',
      id: 'mensalidades',
      name: 'beneficiary.mensalidades',
      route: Routes.MENSALIDADES,
      order: 2,
      closeable: true,
    },
  ];

  applicationModuleRegistry.registerGroup({
    entry: 'financeiro',
    id: 'financeiro',
    name: 'beneficiary.financeiro',
    modules,
    order: 4,
  });
}
